<template>
  <CContainer>
    <CRow class="justify-content-center">
      <CCol md="12" class="text-start">
        <CAlert
          v-if="reqResponse.message"
          class="mt-4"
          :color="reqResponse.type"
          :show="!!reqResponse.message"
        >
          {{ reqResponse.message }}
        </CAlert>
        <CForm class="mb-2">
          <CRow>
            <CCol sm="12" class="pe-1">
              <p class="mb-1">Set limit:</p>
              <div class="form-group">
                <input
                  v-model="form.limit"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': reqResponse.errors['limit'] }"
                  placeholder="No limit"
                  :disabled="!isFormEditable"
                  @input="setLimit($event.target.value)"
                />
                <div
                  v-if="reqResponse.errors['limit']"
                  class="invalid-feedback"
                >
                  {{ reqResponse.errors["limit"][0] }}
                </div>
              </div>
            </CCol>
          </CRow>

          <CRow>
            <CCol sm="12" class="mb-3">
              <p class="mt-1 mb-2">Apply limit for:</p>
              <CCheckBox
                class="custom-checkbox"
                label="STU Passes initiated by the student"
                v-model="form.student_pass"
                :custom="true"
                :disabled="!isFormEditable"
              />
              <CCheckBox
                class="custom-checkbox mb-2"
                label="TCH (PRX) Passes"
                v-model="form.proxy_pass"
                :custom="true"
                :disabled="!isFormEditable"
              />
              <div class="ps-2 mb-2">
                <CCheckBox
                  class="custom-radio"
                  name="teacher_override"
                  v-for="(option, index) in radiosOptions"
                  :key="index"
                  :label="option.label"
                  type="radio"
                  v-show="form.proxy_pass"
                  :checked="form.teacher_override == option.value"
                  :value="option.value"
                  @change="(e) => (form.teacher_override = e.target.value)"
                  :disabled="!isFormEditable"
                />
              </div>

              <CCheckBox
                class="custom-checkbox"
                label="KSK Passes students initiate at a Kiosk."
                v-model="form.kiosk_pass"
                :custom="true"
                :disabled="!isFormEditable"
              />
            </CCol>
          </CRow>
          <div clas="d-flex">
            <div><strong>Notes:</strong></div>
            <div>
              APT passes are not affected by this limit.<br />
              A "-" allows for unlimited passes.
            </div>
          </div>

          <div class="form-group form-actions mt-4 text-center">
            <div class="d-flex align-items-center justify-content-center">
              <div @click="submit()">
                <CLoadingButton
                  :spinner="isLoading"
                  :disabled="isLoading || !isFormEditable"
                  :loading="isLoading"
                  class="me-2 px-5 py-3 btn bg-gradient-blue text-white"
                >
                  Submit
                </CLoadingButton>
              </div>
              <router-link
                v-if="!isInView && userRole !== 'teacher'"
                :disabled="!isFormEditable"
                class="text-graident-blue ms-3"
                to="/limits/limit-active-pass"
              >
                <div class="d-flex align-items-center" @click="goToFullMenu()">
                  <img
                    width="18"
                    class="m-0 me-2"
                    src="@/assets/images/icons/gradient-link.png"
                  />
                  <span class="text-graident-blue">Go to full menu</span>
                </div>
              </router-link>
            </div>
          </div>
        </CForm>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  name: "CreateLimitActivePassForm",
  props: ["isInView"],
  emits: ["setActivePassLimit", "limitActivePassCreated", "closeModal"],
  data() {
    return {
      isLoading: false,
      form: {
        limit: "",
        student_pass: false,
        proxy_pass: false,
        kiosk_pass: false,
        teacher_override: "0"
      },
      reqResponse: {
        type: "",
        message: "",
        errors: {}
      },
      radiosOptions: [
        {
          value: "1",
          label:
            "Allow teachers to override the limit (they will get an alert first)",
          props: { disabled: false }
        },
        {
          value: "0",
          label: "Don't allow teachers to override the limit",
          props: { disabled: false }
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      activePassLimits: "activePass/activePassLimits",
      userRole: "authentication/getUserRole"
    }),
    isFormEditable() {
      return this.userRole === "admin"
    }
  },
  watch: {
    activePassLimits: function (val) {
      this.setFormData(val)
    }
  },
  created() {
    if (!this.activePassLimits) {
      this.$store
        .dispatch("activePass/getActivePassLimits")
        .then((response) => {
          const data = response.data.data
          this.setFormData(data)
        })
    } else {
      this.setFormData(this.activePassLimits)
    }
    this.radiosOptions.map(
      (item) => (item.props.disabled = !this.isFormEditable)
    )
  },
  methods: {
    setFormData(data) {
      if (data && Object.keys(data).length) {
        this.$emit("setActivePassLimit", data.limit)
        this.form = {
          limit: data.limit === "" ? null : data.limit,
          student_pass: !!data.student_pass,
          proxy_pass: !!data.proxy_pass,
          kiosk_pass: !!data.kiosk_pass,
          teacher_override: data.teacher_override.toString()
        }
      } else {
        this.resetForm()
      }
    },
    resetForm() {
      this.form = {
        limit: null,
        student_pass: false,
        proxy_pass: false,
        kiosk_pass: false,
        teacher_override: "0"
      }
    },
    submit() {
      if (this.isFormEditable) {
        this.resetResponseMessages()
        const inputsData = {
          limit: this.form.limit === "" ? null : this.form.limit,
          student_pass: this.form.student_pass,
          proxy_pass: this.form.proxy_pass,
          kiosk_pass: this.form.kiosk_pass,
          teacher_override: this.form.teacher_override
        }
        this.isLoading = true
        this.$store
          .dispatch("activePass/createActivePassLimit", inputsData)
          .then((response) => {
            const data = response.data.data
            this.setFormData(data)
            this.setSuccessResponse("Successfully updated.")
            setTimeout(() => {
              this.resetResponseMessages()
              this.$emit("limitActivePassCreated")
            }, 1000)
            this.isLoading = false
          })
          .catch((err) => {
            const response = err.response.data
            this.setErrorResponse(response.message, response.errors)
            this.isLoading = false
          })
      }
    },
    resetResponseMessages() {
      this.reqResponse = {
        type: "",
        message: "",
        errors: {}
      }
    },
    setSuccessResponse(message) {
      this.reqResponse = {
        type: "success",
        message: message ? message : "Success!",
        errors: {}
      }
    },
    setErrorResponse(message, errors) {
      this.reqResponse = {
        type: "danger",
        message: message ? message : "Someting went wrong!",
        errors: errors ? errors : {}
      }
    },
    refreshForm() {
      this.resetForm()
      if (this.activePassLimits) {
        this.setFormData(this.activePassLimits)
      }
      this.resetResponseMessages()
    },
    goToFullMenu() {
      this.$emit("closeModal")
    },
    setLimit(value) {
      const numbers = /^[0-9]+$/
      if (value) {
        if (value.match(numbers)) {
          this.form.limit = parseInt(value) > 0 ? parseInt(value) : 0
        } else {
          this.form.limit = value === "-" || value === "" ? value : ""
        }
      }
    }
  }
}
</script>
